import React from "react";
import './noFound.css'
import { Route } from 'react-router-dom'
import { Button } from "semantic-ui-react";
const noFound = (props) => {
  return (
    <div className="notFound-wrapper">
      <h1 className="notFound">404</h1>
      <p className="notFound">Oops! Something is wrong.</p>
      <Route render={({ history}) => (
        <Button
          className="book-service-btn"
          onClick={(_) => {
            props.setPage(0);
            history.push('/')
          }}
        >
          Start over
        </Button>
         )} />
    </div>
  );
};

export default noFound;
